// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"image-slider_wrapper__ohAvQ","swiper-nav-prev":"image-slider_swiper-nav-prev__yGPVY","swiper-nav-next":"image-slider_swiper-nav-next__CwBeY"};